import { render, staticRenderFns } from "./CustomerWindow.vue?vue&type=template&id=07cdfccc&scoped=true&"
import script from "./CustomerWindow.vue?vue&type=script&lang=js&"
export * from "./CustomerWindow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWindow.vue?vue&type=style&index=0&id=07cdfccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cdfccc",
  null
  
)

export default component.exports